interface IStatus {
    status: string;
    shipment_status: string;
    payment_status: string;
}

export function getStatus(statusNumber: string): IStatus {
    switch (statusNumber) {
        case '2':
            return {
                status: 'open',
                shipment_status: 'unpacked',
                payment_status: 'any',
            };
        case '3':
            return {
                status: 'open',
                shipment_status: 'unfulfilled',
                payment_status: 'any',
            };
        case '4':
            return {
                status: 'open',
                shipment_status: 'any',
                payment_status: 'pending',
            };
        case '1':
        default:
            return {
                status: 'open',
                shipment_status: 'any',
                payment_status: 'any',
            };
    }
}
